import { useAppSelector, DisplayMode } from "./store";

import LoginPage from "./LoginPage";
import LobbyPage from "./LobbyPage";
import GamePage from "./GamePage";
import SplashPage from "./SplashPage";
import EndPage from "./EndPage";

import "./App.css";

function App() {
  const display = useAppSelector((state) => {
    return state.display;
  });

  let main: JSX.Element;

  switch (display.mode) {
    case DisplayMode.lobby:
      main = <LobbyPage />;
      break;
    case DisplayMode.ingame:
      main = <GamePage />;
      break;
    case DisplayMode.splash:
      main = <SplashPage />;
      break;
    case DisplayMode.login:
      main = <LoginPage />;
      break;
    case DisplayMode.end:
      main = <EndPage />;
      break;
    default:
      main = (
        <div className="centerContainer height100">
          <h1>Oops</h1>
          <div>{display.mode} is an invalid display mode.</div>
        </div>
      );
  }

  return <div className="app">{main}</div>;
}

export default App;
